import React from 'react';
import styled from 'styled-components';
export const CenterJustifiedContainer = styled.div `
    display: flex;
    flex: 1;
    justify-content: center;
`;
export const CenterJustifiedContentContainer = styled.div `
    align-self: center;
    grid-column-start: 2;
    grid-column-end: 2;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 800px;
    background-color: ${(props) => props.theme.colors.surface};
    border: 1px solid ${(props) => props.theme.colors.border};
    margin-top: 4rem;
    margin-bottom: 4rem;
    border-radius: 4px;
`;
export const CenterJustifiedSpacer = styled.div `
    position: relative;
    height: 2.5rem;

    &:after {
        content: '';
        background-color: ${(props) => props.theme.colors.background};
        position: absolute;
        height: 2.5rem;
        width: calc(100% + 2px);
        left: -1px;
        bottom: 0;
        border-top: 1px solid ${(props) => props.theme.colors.border};
        border-bottom: 1px solid ${(props) => props.theme.colors.border};
    }
`;
const CenterJustifiedLayout = ({ children }) => {
    return (React.createElement(CenterJustifiedContainer, null,
        React.createElement(CenterJustifiedContentContainer, null, children)));
};
CenterJustifiedLayout.Spacer = CenterJustifiedSpacer;
export default CenterJustifiedLayout;
//# sourceMappingURL=index.js.map